import React from "react";
import "./NavigationPanel.css";
import BracksetHeaderSimple from "./BracksetHeaderSimple";
import HomeScreenAccountInfoCard from "components/account-screen/HomeScreenAccountInfoCard";
import NavigationTabs from "./NavigationTabs";
import CookieManager from "utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import { navigateToContactUsPage } from "utilities/js/NavigationHelper";
import BracketList from "./BracketList";
import InboxControl from "components/account-screen/InboxControl";
import { isLoggedIn } from "utilities/js/ActionLibrary";
import { isMobile } from "utilities/js/DeviceLibrary";


const InstagramLogo = Constants.ICON_INSTAGRAM;
const TwitterLogo = Constants.ICON_TWITTER;

const cookieManager = new CookieManager();

class NavigationPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showRecentBrackets: this.props.showRecentBrackets
        };

    }

    get navigationTabs() {
        if (isLoggedIn()) {
            return (<NavigationTabs isVertical="true" hideMobile="true" onHomeClick={this.props.onHomeClick} onCommunityClick={this.props.onCommunityClick} onPersonalClick={this.props.onPersonalClick}></NavigationTabs>)
        }
    }


    hideRecentBrackets() {
        // let recentBracketsList = document.querySelector('#recentBrackets');
        // recentBracketsList.classList.add('hidden');
    }

    //detect if we're on a phone or not, and if so, just don't render this to save a callout
    //We cannot avoid this desktop, even if the screen is small because resizing is allowed
    get recentBracketDisplay() {
        if (this.state.showRecentBrackets && !isMobile() ) {
            return (
                <div id="recentBrackets" className="nav-panel-simple">
                    <div className="nav-panel-title">Recent</div>
                    <div className="bracket-list-container">
                        <BracketList onEmpty={this.hideRecentBrackets} limit='3'></BracketList>
                    </div>
                </div>
            );
        }
    }

    render() {

        return (
            <>
                <div className="home-nav-left-column hide-mobile"></div>
                <div className="home-nav-left-column-fixed hide-mobile">
                    <div className="left-column-main-content">
                        <BracksetHeaderSimple></BracksetHeaderSimple>
                        <div className="nav-panel-simple">
                            <HomeScreenAccountInfoCard></HomeScreenAccountInfoCard>
                            <InboxControl notifications={this.props.notifications}></InboxControl>
                        </div>
                        <div className="nav-panel-simple">
                            {this.navigationTabs}
                        </div>
                        {this.recentBracketDisplay}
                    </div>
                    <div>
                        <div className="brackset-footer-links">
                            <div className="brackset-footer-socials">
                                <img className="brackset-footer-social-icon" src={TwitterLogo} alt="logo-icon"></img>
                                <img className="brackset-footer-social-icon" src={InstagramLogo} alt="logo-icon"></img>

                            </div>
                            <div className="brackset-footer-contact-us">
                                <div className="contact-us-prompt">Questions? Feedback? Please reach out and let us know</div>
                                <button className="contact-us-button" onClick={navigateToContactUsPage}>Contact Us</button>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        )
    }
}

export default NavigationPanel;
